import React from "react";
import {
  ErrorText,
  FieldCard,
  FieldLabel,
  FieldPlaceholder,
  FieldValue,
} from "./ContextEdit.styles";

interface InputFieldProps {
  label: string;
  value: string;
  placeholder?: string;
  onClick?: () => void;
  width?: string;
  flex?: boolean;
  isActive?: boolean;
  disabled?: boolean;
  hasError?: boolean;
  errorMessage?: string;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  value,
  placeholder,
  onClick,
  width,
  flex,
  isActive,
  disabled,
  hasError,
  errorMessage,
}) => (
  <>
    <FieldCard
      onClick={disabled ? undefined : onClick}
      $width={width}
      $flex={flex}
      $isActive={!disabled && isActive}
      $hasError={hasError}
    >
      <FieldLabel $isActive={!disabled && isActive}>{label}</FieldLabel>
      {value ? (
        <FieldValue title={value}>{value}</FieldValue>
      ) : (
        <FieldPlaceholder>{placeholder || "\u00A0"}</FieldPlaceholder>
      )}
    </FieldCard>
    {hasError && errorMessage && <ErrorText>{errorMessage}</ErrorText>}
  </>
);

export default InputField;
